import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["src"]

import { toRefs } from 'vue';
import { clubUUID } from '@/shared/state';
import { setDefaultImage, getImageUrl } from '@/utils/global'


export default /*#__PURE__*/_defineComponent({
  __name: 'pathImage',
  props: {
    gender: {
        type: String,
        default: '',
    },
    path_image: {
        type: String,
        default: '',
    },
    classes: {
        type: String,
        default: '',
    },
    refs: {
        type: String,
        default: '',
    }
},
  setup(__props) {

const props = __props;

const { classes, path_image } = toRefs(props);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    class: _normalizeClass(_unref(classes)),
    ref: __props.refs,
    src: _unref(getImageUrl)(_unref(path_image)),
    onError: _cache[0] || (_cache[0] = ($event: any) => (_unref(setDefaultImage)($event, '@/assets/img/icons/member.png', _unref(getImageUrl)(_unref(path_image))))),
    alt: "Selected Image"
  }, null, 42, _hoisted_1))
}
}

})